module.exports = __webpack_public_path__ + "img/305.add847bb.png";